import { render } from "./CIS-List-Page-Link.vue?vue&type=template&id=bd4a005e&scoped=true"
import script from "./CIS-List-Page-Link.vue?vue&type=script&lang=js"
export * from "./CIS-List-Page-Link.vue?vue&type=script&lang=js"

import "./CIS-List-Page-Link.vue?vue&type=style&index=0&id=bd4a005e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4a005e"]])

export default __exports__